module.exports = __webpack_public_path__ + "assets/side-corner-narrow.d64f4db3.svg";